import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { SidebarProvider } from './context/SidebarContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './components/Auth/Login';
import Register from './components/Auth/Register';
import Dashboard from './components/Dashboard/Dashboard';

// Page imports
import Users from './pages/Users';
import Barcodes from './pages/Barcodes';
import Import from './pages/Import';
import Records from './pages/Records';
import Settings from './pages/Settings';
import Scan from './pages/Scan';
import CreateRecord from './pages/CreateRecord';
import ScanUpdate from './pages/ScanUpdate';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SidebarProvider>
          <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          {/* Protected Routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          
          {/* Admin Routes */}
          <Route
            path="/users"
            element={
              <ProtectedRoute>
                <Users />
              </ProtectedRoute>
            }
          />
          <Route
            path="/barcodes"
            element={
              <ProtectedRoute>
                <Barcodes />
              </ProtectedRoute>
            }
          />
          <Route
            path="/import"
            element={
              <ProtectedRoute>
                <Import />
              </ProtectedRoute>
            }
          />
          <Route
            path="/records"
            element={
              <ProtectedRoute>
                <Records />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            }
          />
          
          {/* Vehicle Executive Routes */}
          <Route
            path="/scan"
            element={
              <ProtectedRoute>
                <Scan />
              </ProtectedRoute>
            }
          />
          <Route
            path="/create-record"
            element={
              <ProtectedRoute>
                <CreateRecord />
              </ProtectedRoute>
            }
          />
          
          {/* Service Engineer Routes */}
          <Route
            path="/scan-update"
            element={
              <ProtectedRoute>
                <ScanUpdate />
              </ProtectedRoute>
            }
          />

          {/* Redirects */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/unauthorized" element={<div className="flex items-center justify-center h-screen text-center"><div><h1 className="text-2xl font-bold mb-2">403 - Unauthorized</h1><p className="text-slate-600">You do not have permission to access this page.</p></div></div>} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </SidebarProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
